import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Typography,
  Card,
  Statistic,
  Spin,
  Button,
  Form,
  Row,
  Col,
  Flex,
  Steps,
} from "antd";

//PROJECT IMPORTS
import MainLayout from "../../../../../components/layouts/MainLayout";
import CustomButton from "../../../../../components/custom/CustomButton";
import TopContent from "../../../../../components/layouts/TopContent";
import cnt from "../../../../../services/definedConstant";
import { BOM } from "../../../../../services/definedMethod";
import DetailForm from "./forms/DetailForm";
import ChargesForm from "./forms/ChargesForm";
import TermsForm from "./forms/TermsForm";
import Preview from "./forms/Preview";
import "../../steps.css";
import { accountStatus } from "../../../../../components/facilities/AccountFacility";
import { apiConfig, labelConfig, staticConfig } from "../../../group.config";
import styles from "../../../../../assets/styles/styles";
import dayjs from "dayjs";

const GroupGsimApplication = (props) => {
  const { state } = useLocation();

  //DECLARED VARIABLES
  const [isProductSelected, setIsProductSelected] = useState(false);
  const [isNextAllowed, setIsNextAllowed] = useState(false);
  const [isStepDisabled, setIsStepDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [showDetailsForm, setShowDetailsForm] = useState(false);
  const [maxOverdraftAmt, setMaxOverdraftAmt] = useState(null);
  const [groupInfo, setGroupInfo] = useState(null);
  const [chargeTableSource, setChargeTableSource] = useState([]);
  const [templateProdDetail, setTemplateProdDetail] = useState({});
  const [customerParam, setCustomerParam] = useState({});
  const [current, setCurrent] = useState(0);
  const [searchParam, setSearchParam] = useState("");
  const [isLienAllowed, setIsLienAllowed] = useState(false);
  const [isOverdraftAllowed, setIsOverdraftAllowed] = useState(false);
  const [isMinReqBalEnforced, setIsMinReqBalEnforced] = useState(false);
  const [isLockInDefined, setIsLockInDefined] = useState(false);

  const { userData } = props;
  const { Text } = Typography;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  // CHARGES FORM REQUIRED VARIABLES
  const [chargeTableCount, setChargeTableCount] = useState(0);

  // ENDPOINT DECLARED VARIABLES
  const [productOptions, setProductOptions] = useState([]);
  const [fieldOfficerData, setFieldOfficerData] = useState([]);
  const [currencyData, setCurrencyData] = useState({});

  const [
    interestCompoundingPeriodTypeOptions,
    setInterestCompoundingPeriodTypeOptions,
  ] = useState([]);
  const [
    interestPostingPeriodTypeOptions,
    setInterestPostingPeriodTypeOptions,
  ] = useState([]);
  const [interestCalculationTypeOptions, setInterestCalculationTypeOptions] =
    useState([]);
  const [
    interestCalculationDaysInYearTypeOptions,
    setInterestCalculationDaysInYearTypeOptions,
  ] = useState([]);
  const [
    lockinPeriodFrequencyTypeOptions,
    setLockinPeriodFrequencyTypeOptions,
  ] = useState([]);
  const [customerMemberList, setCustomerMemberList] = useState([]);
  const [customerDetails, setCustomerDetails] = useState(null);
  const [customerTableSource, setCustomerTableSource] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCustomerSelected, setIsCustomerSelected] = useState(false);
  const [officeId, setOfficeId] = useState("");
  const [charges] = useState([]);
  const [chargesOptions, setChargesOptions] = useState([]);

  // DECLARED VARIABLES FOR CHARRGES FORM
  const [chargesValue, setChargesValue] = useState(null);

  // ENDPOINT DECLARED VARIABLES
  const [formData, setFormData] = useState({
    details: null,
    terms: null,
    charges: null,
  });

  useEffect(() => {
    // console.log(state);
    getCustomerMembers();
    getDetailById();
  }, []);

  const getCustomerMembers = () => {
    const url = `${apiConfig.Groups}/${state.id}?`;
    const params = {
      associations: "activeClientMembers",
    };
    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        let tempCustomerMemebers = [];
        let tempCustomerDetails = [];

        objDetail?.activeClientMembers?.forEach((element) => {
          tempCustomerMemebers.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objDetail?.activeClientMembers?.forEach((element) => {
          tempCustomerDetails.push({
            key: element.id,
            id: element.id,
            name: element.displayName,
            office: element.officeName,
          });
        });

        setCustomerMemberList(tempCustomerMemebers);
        setCustomerDetails(tempCustomerDetails);

        setIsLoading(false);
      }
    });
  };

  const getDetailById = () => {
    const url = `${apiConfig.SavingsAccounts}/template`;
    const params = {
      groudId: state.id,
      staffInSelectedOfficeOnly: true,
    };
    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        let tempProductOptions = [];

        objDetail?.productOptions
          .filter((item) => item?.allowOverdraft === false)
          .forEach((element) => {
            tempProductOptions.push({
              value: element.id,
              label: element.name,
            });
          });
        setProductOptions(tempProductOptions);
        setIsLoading(false);
      }
    });
  };

  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;
    if (!searchKey) {
      return;
    }

    setSearchParam(searchKey);
  }

  const onSearch = () => {
    setIsProductSelected(false);
    useForm.resetFields();
    setChargeTableSource([]);
    if (!searchParam.trim()) {
      BOM.AlertMsg(cnt.WARNING, "Search parameter is required");
      return;
    }
    const params = {
      exactMatch: true,
      query: searchParam.trim(),
      resource: "clients,clientIdentifiers",
    };
    const url = apiConfig.Search;
    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        let tempProducts = [];

        objList?.forEach((element) => {
          tempProducts.push({
            entityAccountNo: element.entityAccountNo
              ? element.entityAccountNo
              : "",
            entityId: element.entityId ? element.entityId : "",
            entityMobileNo: element.entityMobileNo
              ? element.entityMobileNo
              : "",
            entityName: element.entityName ? element.entityName : "",
            entityType: element.entityType ? element.entityType : "",
          });
        });

        if (tempProducts[0] === undefined) {
          BOM.AlertMsg(cnt.DANGER, "No matching client found.");
          setShowDetailsForm(false);
          setIsLoading(false);
          return;
        }

        setCustomerParam(tempProducts[0]);
        setGroupInfo(tempProducts[0]);
        getProductTemplate(tempProducts[0]);
        setShowDetailsForm(true);
        setIsLoading(false);
      }
    });
  };

  const onChange = (value) => {
    setCurrent(value);
  };

  const onFinishDetailsForm = (values) => {
    values.submittedOnDate = values.submittedOnDate
      ? BOM.DateTime(values.submittedOnDate, "only-date")
      : values.submittedOnDate;
    setFormData({ ...formData, details: values });
    setCurrent(current + 1);
  };

  const onFinishTermsForm = (values) => {
    setFormData({ ...formData, terms: values });
    setCurrent(current + 1);
  };

  const onFinishChargeForm = (values) => {
    let tempChargeArray = [];
    chargeTableSource.forEach((element, index) => {
      if (element.dueDate === "-") {
        tempChargeArray.push({
          chargeId: element.id,
          amount: element.amountToUse,
        });
      } else {
        tempChargeArray.push({
          chargeId: element.id,
          amount: element.amountToUse,
          dueDate: BOM.DateTime(element.dueDate, "only-date"),
        });
      }
    });

    values.charges = tempChargeArray;

    delete values.chargeId;

    setFormData({
      ...formData,
      charges: values.charges,
    });
    setCurrent(current + 1);
    console.log(values);
  };

  const getProductTemplate = (customerParam) => {
    setIsLoading(true);
    const params = {
      clientId: `${customerParam.entityId}`,
      staffInSelectedOfficeOnly: true,
    };

    const url = `${apiConfig.savingsAccounts}/template`;

    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetail = res;
        let tempProducts = [];

        objDetail?.productOptions
          ?.filter((item) => item.allowOverdraft === true)
          .forEach((element) => {
            tempProducts.push({
              value: element.id,
              label: element.name ? `${element.name} (${element.id})` : "",
            });
          });

        setProductOptions(tempProducts);
        setGroupInfo(customerParam);
        setShowDetailsForm(true);
        setIsLoading(false);
      }
    });
  };

  const onChangeProduct = (productParam) => {
    setIsStepDisabled(false);
    setIsLoading(true);
    const params = {
      groupId: state.id,
      productId: productParam,
      staffInSelectedOfficeOnly: true,
    };
    const url = `${apiConfig.SavingsAccounts}/template`;

    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        setTemplateProdDetail(res);
        const objDetail = res;

        let tempFieldOfficer = [];
        let tempCurrency = objDetail?.currency;
        let tempInterestCompoundingPeriodTypeOptions = [];
        let tempInterestPostingPeriodTypeOptions = [];
        let tempInterestCalculationTypeOptions = [];
        let tempInterestCalculationDaysInYearTypeOptions = [];
        let tempLockinPeriodFrequencyTypeOptions = [];
        let tempPeriodFrequencyTypeOptions = [];
        let tempPreClosurePenalInterestOnTypeOptions = [];
        let tempTaxGroupOptions = [];
        let tempAssetOptions = [];
        let tempEquityOptions = [];
        let tempExpenseOptions = [];
        let tempIncomeOptions = [];
        let tempLiabilityOptions = [];
        let tempCharges = [];
        let tempChargesOptions = [];
        let tempPenaltyOptions = [];
        let tempPaymentTypeOptions = [];

        useForm.setFieldsValue({
          productId: productParam,
          currency: objDetail?.currency?.displayLabel,
          decimalPlaces: objDetail?.currency?.decimalPlaces,
          interestCompoundingPeriodType:
            objDetail?.interestCompoundingPeriodType?.id,
          interestPostingPeriodType:
            objDetail?.interestPostingPeriodType?.id === 0
              ? null
              : objDetail?.interestPostingPeriodType?.id,
          interestCalculationType: objDetail?.interestCalculationType?.id,
          currencyInMultiplesOf: objDetail?.currency?.inMultiplesOf,
          interestCalculationDaysInYearType:
            objDetail?.interestCalculationDaysInYearType?.id,
          nominalAnnualInterestRate: objDetail?.nominalAnnualInterestRate,
          interestCalculationDaysInYearType:
            objDetail?.interestCalculationDaysInYearType?.id,
          withdrawalFeeForTransfers: objDetail?.withdrawalFeeForTransfers,
          enforceMinRequiredBalance: objDetail?.enforceMinRequiredBalance,
          submittedOnDate: dayjs(),
        });

        objDetail?.fieldOfficerOptions?.forEach((element) => {
          tempFieldOfficer.push({
            value: element.id,
            label: element.displayName,
          });
        });
        objDetail?.interestCompoundingPeriodTypeOptions?.forEach((element) => {
          tempInterestCompoundingPeriodTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objDetail?.interestPostingPeriodTypeOptions?.forEach((element) => {
          tempInterestPostingPeriodTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objDetail?.interestCalculationTypeOptions?.forEach((element) => {
          tempInterestCalculationTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objDetail?.interestCalculationDaysInYearTypeOptions?.forEach(
          (element) => {
            tempInterestCalculationDaysInYearTypeOptions.push({
              value: element.id,
              label: element.value,
            });
          }
        );
        objDetail?.lockinPeriodFrequencyTypeOptions?.forEach((element) => {
          tempLockinPeriodFrequencyTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objDetail?.periodFrequencyTypeOptions?.forEach((element) => {
          tempPeriodFrequencyTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objDetail?.preClosurePenalInterestOnTypeOptions?.forEach((element) => {
          tempPreClosurePenalInterestOnTypeOptions.push({
            value: element.id,
            label: element.value,
          });
        });
        objDetail?.taxGroupOptions?.forEach((element) => {
          tempTaxGroupOptions.push({
            value: element.id,
            label: element.name,
          });
        });
        objDetail?.accountingMappingOptions?.assetAccountOptions?.forEach(
          (element) => {
            tempAssetOptions.push({
              value: element.id,
              label: element.name,
            });
          }
        );
        objDetail?.accountingMappingOptions?.equityAccountOptions?.forEach(
          (element) => {
            tempEquityOptions.push({
              value: element.id,
              label: element.name,
            });
          }
        );
        objDetail?.accountingMappingOptions?.expenseAccountOptions?.forEach(
          (element) => {
            tempExpenseOptions.push({
              value: element.id,
              label: element.name,
            });
          }
        );
        objDetail?.accountingMappingOptions?.incomeAccountOptions?.forEach(
          (element) => {
            tempIncomeOptions.push({
              value: element.id,
              label: element.name,
            });
          }
        );
        objDetail?.accountingMappingOptions?.liabilityAccountOptions?.forEach(
          (element) => {
            tempLiabilityOptions.push({
              value: element.id,
              label: element.name,
            });
          }
        );
        objDetail?.paymentTypeOptions?.forEach((element) => {
          tempPaymentTypeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        const chargesLength = objDetail?.charges?.length || 0;
        setChargeTableCount(chargesLength);

        objDetail?.charges?.forEach((element, index) => {
          tempCharges.push({
            key: index + 1,
            id: element?.chargeId ? element?.chargeId : "-",
            name: element?.name ? element?.name : "-",
            type: element?.chargeCalculationType?.value
              ? element?.chargeCalculationType?.value
              : "-",
            amount: element?.amount ? (
              <Statistic
                value={element?.amount}
                precision={2}
                valueStyle={{ fontSize: "16px" }}
              />
            ) : (
              0
            ),
            amountToUse: element.amount ? element.amount : 0,
            collectedOn: element?.chargeTimeType?.value
              ? element?.chargeTimeType?.value
              : "-",
            dueDate: element?.feeOnMonthDay
              ? BOM.DateTime(element?.feeOnMonthDay, "only-date")
              : "-",
            feeInterval: element?.feeInterval?.value
              ? element?.feeInterval?.value
              : "-",
          });
        });

        objDetail?.chargeOptions?.forEach((element) => {
          tempChargesOptions.push({
            value: element.id,
            label: `${element.name}(${element?.currency?.name})`,
            currencyName: element?.currency?.name,
            currencyCode: element?.currency?.code,
          });
        });

        objDetail?.penaltyOptions?.forEach((element) => {
          tempPenaltyOptions.push({
            value: element.id,
            label: element.name,
          });
        });
        setMaxOverdraftAmt(objDetail?.clientOverdraftLimit);
        setFieldOfficerData(tempFieldOfficer);
        setCurrencyData(tempCurrency);
        setInterestCompoundingPeriodTypeOptions(
          tempInterestCompoundingPeriodTypeOptions
        );
        setInterestPostingPeriodTypeOptions(
          tempInterestPostingPeriodTypeOptions
        );
        setInterestCalculationTypeOptions(tempInterestCalculationTypeOptions);
        setInterestCalculationDaysInYearTypeOptions(
          tempInterestCalculationDaysInYearTypeOptions
        );
        setLockinPeriodFrequencyTypeOptions(
          tempLockinPeriodFrequencyTypeOptions
        );
        setChargeTableSource(tempCharges);

        const chargeForTableData = tempChargesOptions.filter(
          (item) => item.currencyCode === tempCurrency.code
        );
        useForm.setFieldsValue({
          chargeId: "",
        });
        setChargesOptions([...chargeForTableData]);
        setIsProductSelected(true);

        if (objDetail?.clientOverdraftLimit > 0) {
          setIsStepDisabled(false);
          setIsNextAllowed(true);
        }
        setShowDetailsForm(true);
        setIsLoading(false);
      }
    });
  };

  const handleOverdarftAllowed = (value) => {
    setIsOverdraftAllowed(value);
  };
  const handleLienAllowed = (value) => {
    setIsLienAllowed(value);
  };
  const handleEnforceMin = (value) => {
    setIsMinReqBalEnforced(value);
  };
  const handleLockInPeriod = (e) => {
    if (e.target.value > 0) {
      setIsLockInDefined(true);
    } else {
      setIsLockInDefined(false);
    }
  };

  const forms = [
    <DetailForm
      onSearch={onSearch}
      searchParam={searchParam}
      groupInfo={groupInfo}
      showDetailsForm={showDetailsForm}
      onFinish={onFinishDetailsForm}
      currencyData={currencyData}
      displayFields={isProductSelected}
      form={useForm}
      initialValues={formData.details}
      onChangeProduct={onChangeProduct}
      productOptions={productOptions}
      fieldOfficerData={fieldOfficerData}
      handleSearchInTable={handleSearchInTable}
    />,

    <TermsForm
      onFinish={onFinishTermsForm}
      form={useForm}
      initialValues={formData.terms}
      handleOverdarftAllowed={handleOverdarftAllowed}
      handleLienAllowed={handleLienAllowed}
      handleEnforceMin={handleEnforceMin}
      isLienAllowed={isLienAllowed}
      isLockInDefined={isLockInDefined}
      setIsLockInDefined={setIsLockInDefined}
      handleLockInPeriod={handleLockInPeriod}
      isOverdraftAllowed={isOverdraftAllowed}
      isMinReqBalEnforced={isMinReqBalEnforced}
      maxOverdraftAmt={maxOverdraftAmt}
      currencyData={currencyData}
      interestCompoundingPeriodTypeOptions={
        interestCompoundingPeriodTypeOptions
      }
      interestPostingPeriodTypeOptions={interestPostingPeriodTypeOptions}
      interestCalculationTypeOptions={interestCalculationTypeOptions}
      interestCalculationDaysInYearTypeOptions={
        interestCalculationDaysInYearTypeOptions
      }
      lockinPeriodFrequencyTypeOptions={lockinPeriodFrequencyTypeOptions}
      customerMemberList={customerMemberList}
      customerDetails={customerDetails}
      setCustomerTableSource={setCustomerTableSource}
      customerTableSource={customerTableSource}
      isModalOpen={isModalOpen}
      setIsModalOpen={setIsModalOpen}
      officeId={officeId}
      isCustomerSelected={isCustomerSelected}
      setIsCustomerSelected={setIsCustomerSelected}
    />,

    <ChargesForm
      onFinish={onFinishChargeForm}
      form={useForm}
      userData={userData}
      initialValues={formData.charges}
      chargePlaceholder={BOM.handlePlaceholderMsg(
        labelConfig.charges,
        "select"
      )}
      chargesOptions={chargesOptions}
      chargesData={charges}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      setChargesValue={setChargesValue}
      chargeTableSource={chargeTableSource}
      setChargeTableSource={setChargeTableSource}
      chargeTableCount={chargeTableCount}
      setChargeTableCount={setChargeTableCount}
    />,

    <Preview
      formData={formData}
      currencyData={currencyData}
      templateProdDetail={templateProdDetail}
      productOptions={productOptions}
      groupInfo={groupInfo}
      chargeTableSource={chargeTableSource}
    />,
  ];

  const isLastStep = current === forms.length - 1;

  const nextButtonClick = () => {
    if (!isStepDisabled) {
      useForm.submit();
    } else {
      return null;
    }
  };

  const prevButtonClick = () => {
    setCurrent(current - 1);
  };

  function onCancel() {
    navigate("/detail-group", {
      state: {
        id: state.id,
      },
    });
  }

  const onSubmit = (formValues) => {
    if (customerTableSource.length === 0) {
      BOM.AlertMsg(
        cnt.WARNING,
        "Please select at least one client before submitting the GSIM application"
      );
      return;
    }

    const applicationNumber = Math.floor(
      1000000000 + Math.random() * 9000000000
    ).toString();
    formValues = {
      ...formData.details,
      ...formData.terms,
      charges: formData.charges,
      groupId: state.id,
      allowOverdraft: true,
      dateFormat: "dd MMMM yyyy",
      monthDayFormat: "dd MMMM",
      locale: "en",
      withHoldTax: templateProdDetail?.withHoldTax,
      isGSIM: true,
      applicationId: applicationNumber,
    };

    delete formValues.currency;
    delete formValues.currencyInMultiplesOf;
    delete formValues.decimalPlaces;
    delete formValues.minimumBalance;

    const tempCustomerArray = customerTableSource.map(
      (element, index, array) => {
        const isFirst = index === 0;
        const isLast = index === array.length - 1;

        return {
          clientId: element.id,
          ...formValues,
          ...(isFirst && { isParentAccount: true }),
          ...(isLast && { lastApplication: true }),
        };
      }
    );

    formValues.clientArray = tempCustomerArray;

    const url = `${apiConfig.SavingsAccounts}/gsim`;
    const body = {
      clientArray: formValues.clientArray,
      method: "POST",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(cnt.SUCCESS, labelConfig.newGroupSavingAppMsg);
        navigate("/detail-group", {
          state: { ...state },
        });
        setIsLoading(false);
      }
    });
  };

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent
        pageTitle={labelConfig.newGsimApplication}
        pageItems={staticConfig.gsimApplicationBreadcrumbItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card title={labelConfig.accountSetup} style={styles.cardWrapper}>
          <div>
            <Row
              gutter={{
                xs: 8,
                sm: 16,
                md: 24,
                lg: 32,
              }}
              style={{ marginBottom: 25 }}
            >
              <Col span={24}>
                <Row style={{ justifyContent: "space-between" }}>
                  {/* Navigation section */}
                  <Card style={styles.cardSteps}>
                    <Steps
                      current={current}
                      onChange={onChange}
                      direction="vertical"
                      style={{ height: "600px" }}
                      items={[
                        {
                          title: <Text strong>{labelConfig.details}</Text>,
                        },

                        {
                          title: <Text strong>{labelConfig.terms}</Text>,
                          disabled: isStepDisabled,
                        },

                        {
                          title: <Text strong>{labelConfig.charges}</Text>,
                          disabled: isStepDisabled,
                        },

                        {
                          title: <Text strong>{labelConfig.preview}</Text>,
                          disabled: isStepDisabled,
                        },
                      ]}
                    />
                  </Card>
                  {/* Form Section */}
                  <Card style={styles.cardStepDisplay}>
                    <div>{forms[current]}</div>
                  </Card>
                </Row>
              </Col>
            </Row>

            {/* Submitt section */}
            <Card
              style={{
                marginBottom: 25,
                boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                borderRadius: 20,
                padding: 5,
              }}
            >
              <Flex
                justify="space-between"
                style={{ paddingLeft: "20px", paddingRight: "40px" }}
              >
                {current === 0 && (
                  <Button
                    style={{
                      width: "12%",
                      height: "15%",
                      backgroundColor: "white",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                      borderRadius: 20,
                      color: "black",
                    }}
                    onClick={onCancel}
                  >
                    Cancel
                  </Button>
                )}
                {current > 0 && (
                  <Button
                    style={{
                      width: "10%",
                      height: "15%",
                      backgroundColor: "#15CCAE",
                      color: "white",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                      borderRadius: 20,
                    }}
                    onClick={prevButtonClick}
                  >
                    Prev
                  </Button>
                )}
                {!isLastStep && (
                  <Button
                    style={{
                      width: "10%",
                      height: "15%",
                      backgroundColor: "#15CCAE",
                      color: "white",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                      borderRadius: 20,
                    }}
                    onClick={nextButtonClick}
                  >
                    Next
                  </Button>
                )}
                {isLastStep && BOM.HasPermission("CREATE_GSIMACCOUNT") && (
                  <CustomButton
                    content="Submit"
                    style={{
                      width: "10%",
                      marginLeft: "auto",
                      boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                    }}
                    onClick={onSubmit}
                    backgroundColor="#fff"
                    colorText="black"
                    hoverBackground="#F5F5F5"
                  />
                )}
              </Flex>
            </Card>
          </div>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupGsimApplication);
